import { render, staticRenderFns } from "./ReviewTypeStep.vue?vue&type=template&id=e0893d22&scoped=true"
import script from "./ReviewTypeStep.ts?vue&type=script&lang=ts&external"
export * from "./ReviewTypeStep.ts?vue&type=script&lang=ts&external"
import style0 from "./ReviewTypeStep.vue?vue&type=style&index=0&id=e0893d22&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0893d22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0893d22')) {
      api.createRecord('e0893d22', component.options)
    } else {
      api.reload('e0893d22', component.options)
    }
    module.hot.accept("./ReviewTypeStep.vue?vue&type=template&id=e0893d22&scoped=true", function () {
      api.rerender('e0893d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Steps/ReviewTypeStep.vue"
export default component.exports